import { api } from '../index';

const prefix = '/api/boxing/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectInvoice(param) {
	return api.post(prefix + 'selectInvoice', param);
}

export function apiInsertBox(param) {
	return api.post(prefix + 'insertBox', param);
}

export function apiDeleteBox(param) {
	return api.post(prefix + 'deleteBox', param);
}

export function apiDeleteBoxBatch(param) {
	return api.post(prefix + 'deleteBoxBatch', param);
}

export function apiAdjustBox(param) {
	return api.post(prefix + 'adjustBox', param);
}

export function apiSelectBoxItemList(param) {
	return api.post(prefix + 'selectBoxItemList', param);
}

export function apiUpdateBoxItemList(param) {
	return api.post(prefix + 'updateBoxItemList', param);
}

export function apiClearBoxInformation(param) {
	return api.post(prefix + 'clearBoxInformation', param);
}

export function apiSelectInvoiceItemList(invoice_no, for_boxing) {
	return api.get(prefix + 'selectInvoiceItemList', { params: { invoice_no, for_boxing } });
}

export function apiSelectWarehouseMemoList(param) {
	return api.post(prefix + 'selectWarehouseMemoList', param);
}

export function apiSetWarehouseMemo(param) {
	return api.post(prefix + 'setWarehouseMemo', param);
}

export function apiDeleteWarehouseMemoBatch(param) {
	return api.post(prefix + 'deleteWarehouseMemoBatch', param);
}
